import { render, staticRenderFns } from "./TaskDanger.vue?vue&type=template&id=0a4cab9a&scoped=true&"
import script from "./TaskDanger.vue?vue&type=script&lang=js&"
export * from "./TaskDanger.vue?vue&type=script&lang=js&"
import style0 from "./TaskDanger.vue?vue&type=style&index=0&id=0a4cab9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4cab9a",
  null
  
)

export default component.exports